interface PlanPricing {
  perMonth: number;
  perYear: number;
}

/**
 * Calculates the percentage saved by choosing annual billing over monthly.
 */
export const calculateAnnualSavingPercentage = (
  plan: PlanPricing | undefined
): number | undefined => {
  if (!plan) return undefined;
  const monthPerYear = plan.perMonth * 12;
  if (monthPerYear === 0) return undefined;
  const percentage = ((monthPerYear - plan.perYear) / monthPerYear) * 100;
  return Math.trunc(percentage);
};

/**
 * Calculates the subtotal cost for a subscription.
 */
export const calculateSubtotalCost = ({
  plans,
  displayPlan,
  billingCycle,
  memberCount,
  allowMembers,
}: {
  plans: Record<string, PlanPricing> | undefined;
  displayPlan: string | undefined;
  billingCycle: 'month' | 'year';
  memberCount: number;
  allowMembers: boolean;
}): number => {
  if (!plans || !displayPlan || !plans[displayPlan]) return 0;
  const multiplier = !allowMembers ? 1 : Math.max(memberCount, 1);
  const planCost =
    billingCycle === 'year'
      ? plans[displayPlan].perYear
      : plans[displayPlan].perMonth;
  return Math.ceil(planCost * multiplier);
};

/**
 * Masks an email address for display (e.g., "j***@gmail.com").
 */
export const maskEmail = (email: string): string => {
  const atIndex = email.lastIndexOf('@');
  if (atIndex <= 0) return '';
  const localPart = email.substring(0, atIndex);
  const domain = email.substring(atIndex + 1);

  if (domain.length < 10) {
    return `${localPart[0]}***@${domain}`;
  } else {
    return `${localPart[0]}***@${domain.substring(0, 3)} ... ${domain.substring(
      domain.length - 5
    )}`;
  }
};
